import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from './core/Global';


@Injectable()

export class PayrollsService {
	private url: string = Global.url_seguros;
	private _http = inject(HttpClient)
	
	getPayrollsData(policy: number, fecval: string, campus: string): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type','application/json')
		return this._http.get<any>(this.url + 'get-payrolls-detail/'+ policy + "/" + fecval + "/" + campus, { headers: headers }  );
	}
	getPayrollsCampus(policy: number, fecval: string): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type','application/json')
		return this._http.get<any>(this.url + 'get-payrolls-office/'+ policy + "/" + fecval, { headers: headers }  );
	}

	getPayrolls(policy: number, fecval: string): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type','application/json')
		return this._http.get<any>(this.url + 'get-list-payrolls/'+ policy + "/" + fecval, { headers: headers }  );
	}
	getUF(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type','application/json')
		return this._http.post<any>(this.url + 'get-uf', params, { headers: headers }  );
	}
	generate(policy: any, period: any, uf: any): Observable<any> {
		const params = {policy, period, uf}
		let headers = new HttpHeaders().set('Content-Type','application/json')
		return this._http.post<any>(this.url + 'generate-payroll', params, { headers: headers }  );
	}
	calculate(query: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type','application/json')
		return this._http.post<any>(this.url + 'calculate-payroll', query, { headers: headers }  );
	}
}
